import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { UserLoggedInNavigatorNavigationProp } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";

type FileStackParamList = {
  FilesMain: { teamId: string };
  AllFiles: { teamId: string; standalone?: boolean };
};

type FileNavigatorRouteProp<T extends keyof FileStackParamList> = RouteProp<
  FileStackParamList,
  T
>;
type FileNavigatorNavigationProp<T extends keyof FileStackParamList> =
  CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"Files">,
    NativeStackNavigationProp<FileStackParamList, T>
  >;
export type FileNavigatorScreenProp<T extends keyof FileStackParamList> = {
  navigation: FileNavigatorNavigationProp<T>;
  route: FileNavigatorRouteProp<T>;
};

export const FileStack = createNativeStackNavigator<FileStackParamList>();
